import React from "react";

const CreateMeal = React.lazy(() => import("./CreateMealType"));
const Index = React.lazy(() => import("./index"));
const MealTypes = React.lazy(() => import("../../components/MealTypes"));
const MealDetails = React.lazy(() => import("./MealDetails"));

export const mealRoutes = [
  {
    path: "/admin/mealTypes",
    name: "Meal",
    element: <MealTypes />,
  },
  {
    path: "/admin/mealTypes/create",
    name: "Create Meal",
    element: <CreateMeal />,
  },
  {
    path: "/admin/mealTypes/update/:id?",
    name: "Create Meal",
    element: <CreateMeal />,
  },
  {
    path: "/admin/mealTypes/:id",
    name: "Meal",
    element: <MealDetails />,
  },
];
